/**
 * Devuelve el estado inicial para los Toast en una aplicacion.
 * Este estado hace que no se muestre ninguno.
 *
 * @export
 * @returns {ToastState} estado inicial
 */
export function getInitialToastState() {
    return { show: false, message: '', type: 'information' };
}
/**
 * Devuelve el estado inicial para el Dialog en una aplicacion.
 * Este estado hace que el Modal esta oculto.
 *
 * @export
 * @returns {DialogState} estado inicial
 */
export function getInitialDialogState() {
    // Se castea a any porque ToastState tiene duration y DialogState no
    return { ...getInitialToastState(), title: '' };
}
//# sourceMappingURL=notification.js.map